"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _queryString = _interopRequireDefault(require("query-string"));

var _baseClient = require("base-client");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** This gets the query string from the url and transforms it into an object.
 * @returns {object} The query object.
 */
var getQuery = function getQuery() {
  return function () {
    return _queryString.default.parse(_baseClient.history.location.search, {
      arrayFormat: "comma"
    }) || {};
  };
};
/** This updates or replaces the url query.
 * @param {object} [newData] The new query object.
 * @param {string} [url] The new url (optional).
 * @param {bool} [reset] Overwrite the query instead of merge (optional).
 */


var updateQuery = function updateQuery(newData, url, reset) {
  return function (dispatch) {
    var oldQuery = !reset && dispatch(getQuery()) || {};

    var query = _objectSpread(_objectSpread({}, oldQuery), newData);

    var queryString = _queryString.default.stringify(query, {
      arrayFormat: "comma"
    });

    _baseClient.history.push("".concat(url || _baseClient.history.location.pathname, "?").concat(queryString));
  };
};

var clearQuery = function clearQuery(url) {
  return function (dispatch) {
    return dispatch(updateQuery({}, url, true));
  };
};
/** This creates a query string for the standard SmartBIM search api.
 * @param {object} [defaultQuery] The defaults query object.
 * @param {string} [sortName] The attributeName to sort by (optional).
 * @param {string} [sortDir] The direction of the sorting ('asc' or 'desc') (optional).
 * @returns {string} The new query.
 */


var getSearch = function getSearch() {
  var defaultQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var limit = arguments.length > 1 ? arguments[1] : undefined;
  var page = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch) {
    var query = dispatch(getQuery());

    var apiQuery = _objectSpread({}, defaultQuery);

    Object.keys(query).forEach(function (key) {
      if (query[key].type === "filter") {
        apiQuery["filter[".concat(key, "][in]")] = query[key].facets;
      } else if (query[key].type === "match") {
        apiQuery["filter[".concat(key, "][eq]")] = query[key].text;
      } else if (query[key].type === "sort") {
        apiQuery["order[".concat(key, "]")] = query[key].direction;
      } else if (query[key].type === "date") {
        apiQuery["filter[".concat(key, "][start]")] = query[key].start;
        apiQuery["filter[".concat(key, "][end]")] = (0, _moment.default)(query[query[key].end]).add(86399, "seconds").toISOString();
      }
    });
    if (limit) apiQuery.limit = limit;
    if (page) apiQuery.page = page;
    return _queryString.default.stringify(query, {
      arrayFormat: "comma"
    });
  };
};
/** This gets the sort object.
 * @returns {object} An object of sort keys and directions.
 */


var getSorting = function getSorting() {
  return function (dispatch) {
    var query = dispatch(getQuery());
    var filters = {};
    Object.keys(query).forEach(function (key) {
      if (query[key].type === "sort") {
        filters[key] = query[key].direction;
      }
    });
    return filters;
  };
};
/** This clears the sorting list.
 */


var clearSorting = function clearSorting() {
  return function (dispatch) {
    var filters = dispatch(getSorting());
    var newData = {};
    Object.keys(filters).forEach(function (key) {
      newData[key] = undefined;
    });
    dispatch(updateQuery(newData));
  };
};
/** This sets the sorting object.
 * @param {string} [attribute] The name of the attribute
 * @param {('asc'|'desc')} [direction] The direction
 */


var setSorting = function setSorting(attribute, direction) {
  return function (dispatch) {
    if (!direction) {
      dispatch(updateQuery(_defineProperty({}, attribute, undefined)));
      return;
    }

    dispatch(updateQuery(_defineProperty({}, attribute, {
      type: "sort",
      direction: direction
    })));
  };
};
/** This gets the match object.
 * @returns {object} An object of sort keys and directions.
 */


var getMatch = function getMatch() {
  return function (dispatch) {
    var query = dispatch(getQuery());
    var filters = {};
    Object.keys(query).forEach(function (key) {
      if (query[key].type === "match") {
        filters[key] = query[key].text;
      }
    });
    return filters;
  };
};
/** This clears the match list.
 */


var clearMatch = function clearMatch() {
  return function (dispatch) {
    var filters = dispatch(getMatch());
    var newData = {};
    Object.keys(filters).forEach(function (key) {
      newData[key] = undefined;
    });
    dispatch(updateQuery(newData));
  };
};
/** This sets the match object.
 * @param {string} [attribute] The name of the attribute
 * @param {string} [text] The text to match
 * @param {string} [url] The new url to go to
 * @param {bool} [reset] If it should reset the query parameters
 */


var setMatch = function setMatch(attribute, text, url, reset) {
  return function (dispatch) {
    if (!text) {
      dispatch(updateQuery(_defineProperty({}, attribute, undefined)));
      return;
    }

    if (!reset) dispatch(clearFilters());
    dispatch(updateQuery(_defineProperty({}, attribute, {
      type: "match",
      text: text
    }), url, reset));
  };
};
/** This gets the date object.
 * @returns {object} The start and end date in moment form.
 */


var getDates = function getDates() {
  return function (dispatch) {
    var query = dispatch(getQuery());
    var filters = {};
    Object.keys(query).forEach(function (key) {
      if (query[key].type === "date") {
        filters[key] = {
          start: query[key].start ? (0, _moment.default)(query[key].start) : undefined,
          end: query[key].end ? (0, _moment.default)(query[key].end) : undefined
        };
      }
    });
    return filters;
  };
};
/** This clears the date list.
 */


var clearDates = function clearDates() {
  return function (dispatch) {
    var filters = dispatch(getDates());
    var newData = {};
    Object.keys(filters).forEach(function (key) {
      newData[key] = undefined;
    });
    dispatch(updateQuery(newData));
  };
};
/** This sets the date object.
 * @param {string} [attribute] The name of the filter
 * @param {moment} [start] The start date.
 * @param {moment} [end] The end date.
 */


var setDate = function setDate(attribute, start, end) {
  return function (dispatch) {
    if (!start || !end) {
      dispatch(updateQuery(_defineProperty({}, attribute, undefined)));
      return;
    }

    dispatch(clearFilters());
    dispatch(updateQuery(_defineProperty({}, attribute, {
      type: "date",
      start: start && start.toISOString(),
      end: end && end.toISOString()
    })));
  };
};
/** This gets the filter list.
 * @returns {string} The text.
 */


var getFilters = function getFilters() {
  return function (dispatch) {
    var query = dispatch(getQuery());
    var filters = {};
    Object.keys(query).forEach(function (key) {
      if (query[key].type === "filter") {
        filters[key] = query[key].facets;
      }
    });
    return filters;
  };
};
/** This sets a single filter.
 * @param {string} [attribute] The the filter attribute.
 * @param {[string]} [facetArray] The list of facets.
 * @returns {string} The text.
 */


var setFilter = function setFilter(attribute, facetArray) {
  return function (dispatch) {
    dispatch(updateQuery(_defineProperty({}, attribute, {
      type: "filter",
      facets: facetArray
    })));
  };
};
/** This clears the filter list.
 */


var clearFilters = function clearFilters() {
  return function (dispatch) {
    var filters = dispatch(getFilters());
    var newData = {};
    Object.keys(filters).forEach(function (key) {
      newData[key] = undefined;
    });
    dispatch(updateQuery(newData));
  };
};
/** This adds facets to a filter.
 * @param {string} [attribute] The the filter attribute.
 * @param {[string]} [facetArray] The list of facets.
 */


var addFacets = function addFacets(attribute, facetArray) {
  return function (dispatch) {
    var filters = dispatch(getFilters());
    if (!Array.isArray(facetArray)) facetArray = [facetArray];

    if (Object.keys(filters).includes(attribute)) {
      dispatch(setFilter(attribute, [].concat(_toConsumableArray(filters[attribute]), _toConsumableArray(facetArray))));
    } else {
      dispatch(setFilter(attribute, facetArray));
    }
  };
};
/** This removes facets from a filter.
 * @param {string} [attribute] The the filter attribute.
 * @param {[string]} [facetArray] The list of facets.
 */


var removeFacets = function removeFacets(attribute, facetArray) {
  return function (dispatch) {
    var filters = dispatch(getFilters());
    if (!Array.isArray(facetArray)) facetArray = [facetArray];

    if (Object.keys(filters).includes(attribute)) {
      var newFacets = filters[attribute].filter(function (facet) {
        return !facetArray.includes(facet);
      });

      if (newFacets.length > 0) {
        dispatch(setFilter(attribute, newFacets));
      } else {
        dispatch(setFilter(attribute, undefined));
      }
    }
  };
};
/** This replaces the facets in a filter.
 * @param {string} [attribute] The the filter attribute.
 * @param {[string]} [facetArray] The list of facets.
 */


var replaceFacets = function replaceFacets(attribute, facetArray) {
  return function (dispatch) {
    if (!facetArray) {
      dispatch(setFilter(attribute, undefined));
      return;
    }

    if (!Array.isArray(facetArray)) facetArray = [facetArray];

    if (facetArray.length > 0) {
      dispatch(setFilter(attribute, facetArray));
    } else {
      dispatch(setFilter(attribute, undefined));
    }
  };
};

var _default = {
  getQuery: getQuery,
  clearQuery: clearQuery,
  getSearch: getSearch,
  getSorting: getSorting,
  clearSorting: clearSorting,
  setSorting: setSorting,
  getMatch: getMatch,
  clearMatch: clearMatch,
  setMatch: setMatch,
  getDates: getDates,
  clearDates: clearDates,
  setDate: setDate,
  getFilters: getFilters,
  clearFilters: clearFilters,
  addFacets: addFacets,
  removeFacets: removeFacets,
  replaceFacets: replaceFacets
};
exports.default = _default;